<template>
  <b-row>
    <b-col
      cols="12"
      sm="12"
      md="12"
      lg="2"
    >
      <div
        v-for="(opcao, index) in opcoes"
        :key="index"
      >
        <b-button
          v-if="verificarPermissao(opcao.action)"
          class="mb-1"
          block
          variant="gradient-primary"
          :to="opcao.route"
          exact
          :data-cy="opcao.route.name"
        >
          {{ $t(opcao.title) }}
        </b-button>
      </div>
    </b-col>
    <b-col
      cols="12"
      sm="12"
      md="12"
      lg="10"
    >
      <router-view />
    </b-col>
  </b-row>
</template>
<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import { verificarPermissao } from '@/auth/utils'

export default {
  components: {
    BRow,
    BCol,
    BButton,
  },
  data() {
    return {
      verificarPermissao,
      opcoes: [
        {
          title: 'Tipo de Evento',
          route: { name: 'eventTypeSettings' },
          action: 'ROLE_EVENTOS_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Campo Tipo de Evento',
          route: { name: 'eventTypeFieldSettings' },
          action: 'ROLE_EVENTOS_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Descontos de Evento',
          route: { name: 'eventDiscountSettings' },
          action: 'ROLE_EVENTOS_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Tarefas de Evento',
          route: { name: 'eventTaskSettings' },
          action: 'ROLE_EVENTOS_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Responsáveis por Evento',
          route: { name: 'eventManagerSettings' },
          action: 'ROLE_EVENTOS_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Participantes de Evento',
          route: { name: 'eventParticipantSettings' },
          action: 'ROLE_EVENTOS_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Campos de Evento',
          route: { name: 'eventFieldSettings' },
          action: 'ROLE_EVENTOS_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Eventos',
          route: { name: 'events' },
          action: 'ROLE_EVENTOS_CONSULTAR',
          resource: 'ACL',
        },
      ],
      permissionUser: undefined,
    }
  },
}
</script>
